module.exports = __webpack_public_path__ + "img/times.6ea5f7b7.svg";